import { Address, getEmptyAddress } from "@/models/address/address"
import { IAddress } from "@/models/address/address.types"
import { IAccount } from "./account.types"
import dayjs, { Dayjs } from "dayjs"
import { ICustomer } from "../customer/customer.types"
import { Customer } from "../customer/customer"
import { Status } from "@/types/Status"
import {
  getAccountAge,
  getActive,
  getBalanceStatus,
  getIsTerminating,
  getStatus,
} from "@/helpers/accountHelper"

export class Account implements IAccount {
  number: string
  juniferId: number
  name: string
  balance: number
  billingAddress?: IAddress
  createdTime: Dayjs
  startDate: Dayjs
  juniferCustomerId?: number
  endDate?: Dayjs
  supplyAddress?: IAddress
  id?: number
  juniferPropertyId?: number
  cancelled?: boolean
  customer?: ICustomer
  firstName?: string
  lastName?: string

  constructor(
    number: string,
    juniferId: number,
    name: string,
    balance: number,
    createdTime: Dayjs,
    startDate: Dayjs,
    billingAddress?: IAddress,
    junifer_customer_id?: number,
    endDate?: Dayjs,
    supplyAddress?: IAddress,
    id?: number,
    juniferPropertyId?: number,
    cancelled?: boolean,
    customer?: ICustomer,
    firstName?: string,
    lastName?: string,
  ) {
    this.id = id
    this.number = number
    this.juniferId = juniferId
    this.juniferPropertyId = juniferPropertyId
    this.name = name
    this.balance = balance
    this.startDate = startDate
    this.juniferCustomerId = junifer_customer_id
    this.endDate = endDate
    this.cancelled = cancelled
    this.createdTime = createdTime

    if (billingAddress) {
      this.billingAddress = new Address(
        billingAddress.countryCode,
        billingAddress.postcode,
        billingAddress.addressLine1,
        billingAddress.addressLine2,
        billingAddress.addressLine3,
      )
    }

    if (supplyAddress) {
      this.supplyAddress = new Address(
        supplyAddress.countryCode,
        supplyAddress.postcode,
        supplyAddress.addressLine1,
        supplyAddress.addressLine2,
        supplyAddress.addressLine3,
      )
    }

    if (customer) {
      this.customer = new Customer(
        customer.id,
        customer.primary,
        customer.forename,
        customer.surname,
        customer.title,
      )
    }

    this.firstName = firstName
    this.lastName = lastName
  }

  get formattedName(): string {
    if (this.firstName || this.lastName) {
      return [this.firstName, this.lastName].filter(Boolean).join(" ")
    }
    return this.customer?.formattedName ?? ""
  }

  get status(): Status {
    return getStatus(this.cancelled, this.endDate, this.startDate, this.balance)
  }

  get isActive(): boolean {
    return getActive(this.status)
  }
  get isTerminating(): boolean {
    return getIsTerminating(this.status)
  }

  get balanceStatus(): Status {
    return getBalanceStatus(this.balance)
  }

  get accountAge(): string {
    return getAccountAge(this.startDate, this.endDate)
  }
}

export const getEmptyAccount = () =>
  new Account(
    "",
    0,
    "",
    0,
    dayjs(),
    dayjs(),
    getEmptyAddress(),
    0,
    dayjs(),
    getEmptyAddress(),
    0,
  )
